import {
    useEffect,
    useState,
} from 'react';

import api from "../../api/api";

import AdminLayout from "./Components/AdminLayout";
import UserModal from "./Components/UserModal";

export default function AdminUsers() {

    const [users, setUsers] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedUser, setSelectedUser] =
        useState<any>(null);

    const handleResetPassword = async (
        userId: number
    ) => {

        try {

            await api.post(
                `/users/${userId}/reset-password`
            );

            alert(
                'Password reset email sent successfully.'
            );

        } catch {

            alert(
                'Unable to send password reset email.'
            );
        }
    };

    const loadUsers = async () => {

        const response =
            await api.get('/users');

        setUsers(
            response.data
        );
    };

    useEffect(() => {

        loadUsers();

    }, []);

    const handleSave = async (
        data: any
    ) => {

        if (
            selectedUser
        ) {

            await api.put(
                `/users/${selectedUser.id}`,
                data
            );

        } else {

            await api.post(
                '/users',
                data
            );
        }

        setModalOpen(false);

        loadUsers();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this user?'
            )
        ) {
            return;
        }

        await api.delete(
            `/users/${id}`
        );

        loadUsers();
    };

    return (
        <AdminLayout>

            <div className="page-header">

                <h1>
                    Users
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedUser(
                            null
                        );

                        setModalOpen(
                            true
                        );
                    }}
                >
                    Add User
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Created</th>
                    <th>Actions</th>
                </tr>

                </thead>

                <tbody>

                {users.map(
                    (user) => (

                        <tr
                            key={user.id}
                        >

                            <td>
                                {user.name}
                            </td>

                            <td>
                                {user.email}
                            </td>

                            <td>
                                {user.role}
                            </td>

                            <td>
                                {
                                    new Date(
                                        user.created_at
                                    ).toLocaleDateString()
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedUser(
                                                user
                                            );

                                            setModalOpen(
                                                true
                                            );
                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                user.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <UserModal
                    user={selectedUser}
                    onClose={() =>
                        setModalOpen(false)
                    }
                    onSave={handleSave}
                    onResetPassword={() =>
                        handleResetPassword(
                            selectedUser.id
                        )
                    }
                />

            )}

        </AdminLayout>
    );
}
